import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
import type { AccessRequestResponse } from '@hotjar/webapp/domains/activation/request-access/model';
import { getRequestAccessData } from '@hotjar/webapp/domains/activation/request-access/api';

export const GET_ACCESS_REQUEST = 'get-access-request';

export function useAccessRequest(token: string): UseQueryResult<AccessRequestResponse, Error> {
  return useQuery(GET_ACCESS_REQUEST, () => getRequestAccessData(token), {
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!token,
  });
}
